/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ContratoDossieAliases {
  AUTH_CONSTRAINT_DOCUMENTOS = 'auth-constraint-documentos',
  AUTH_CONSTRAINT_INDICE_REAJUSTE = 'auth-constraint-indice-reajuste',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTRATO_DOSSIE_CONTENT = 'contrato-dossie-content',
  FRAGMENT_CONTRATO_DOSSIE_DOCUMENTOS = 'fragment-contrato-dossie-documentos',
  FRAGMENT_CONTRATO_DOSSIE_INFO = 'fragment-contrato-dossie-info',
  FRAGMENT_INDICE_REAJUSTE = 'fragment-indice-reajuste',
  FRAGMENT_TABELA_PRECO = 'fragment-tabela-preco',
  LAYOUT_0 = 'layout-0',
  LAYOUT_CONTRATO_DOSSIE = 'layout-contrato-dossie',
  PANEL_1 = 'panel-1',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_DOCUMENTOS = 'tab-with-content-documentos',
  TAB_WITH_CONTENT_DOSSIE_INFO = 'tab-with-content-dossie-info',
  TAB_WITH_CONTENT_INDICE_REAJUSTE = 'tab-with-content-indice-reajuste',
  TAB_WITH_CONTENT_TABELA_PRECO = 'tab-with-content-tabela-preco',
  TEXT_0 = 'text-0',
}
export { ContratoDossieAliases };
